// WARNING: can't be an enum because of TS reverse mapping of enums
// https://www.typescriptlang.org/docs/handbook/enums.html#reverse-mappings
export const fontWeights = {
  light: 300,
  regular: 400,
  medium: 500,
  bold: 700
} as const;

// Default font stack: Ring Sans with the standard Helvetica/Arial/sans-serif
// fallbacks. Applied everywhere a font-family is set because styled-system
// passes font-family straight to CSS without inheriting from body. Mirrors the
// --default-font CSS variable from ring-safe-web.
export const defaultFont = "RingSans, Helvetica, Arial, sans-serif";

export const fonts = {
  fonts: [defaultFont],
  fontSizes: [
    12, // 0
    14, // 1
    16, // 2
    18, // 3
    20, // 4
    24, // 5
    28, // 6
    32 // 7
  ],
  fontWeights
} as const;
